import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/errors/[slug]/ErrorPageClient.tsx");
